import { Lightbulb, X } from "lucide-react";

import { Motion, Presence } from "../../components/presence";
import { IconButton } from "../../components/ui";
import { t } from "../../i18n/i18n";

/** Bulle d'astuce des annotations (16/10/2026), une seule fois par poste (`useAnnotationTip`) : posée au-dessus de
 *  la barre du bas, sa pointe sur le bouton « Annotation » (`left` : abscisse de la pointe dans la barre), elle
 *  apparaît en fondu et se ferme par sa croix ou d'elle-même à l'ouverture du menu des annotations. L'avis de la
 *  carte l'évite (`data-notice-avoid`). */
export function AnnotationTip({ show, left, onClose }: { show: boolean; left: number; onClose: () => void }) {
  return (
    <Presence show={show}>
      {show && (
        <Motion
          origin="fade"
          role="status"
          data-notice-avoid=""
          data-annotation-tip=""
          className="pointer-events-auto absolute bottom-full z-10 mb-2.5 w-max max-w-[min(300px,calc(100vw-2rem))] rounded-xl border border-line bg-surface py-1 pr-1 pl-3 shadow-float"
          style={{ left: Math.max(0, left - 22) }}
        >
          <div className="flex items-start gap-2">
            <Lightbulb size={14} className="mt-2 shrink-0 text-accent" aria-hidden />
            <p className="min-w-0 flex-1 py-1.5 text-ui leading-snug text-ink">
              {t("Astuce : clic droit sur la carte (appui long au doigt) pour ajouter une annotation.")}
            </p>
            <IconButton size="sm" onClick={onClose} title={t("Fermer l'astuce")} aria-label={t("Fermer l'astuce")}>
              <X size={14} />
            </IconButton>
          </div>
          {/* Pointe vers le bouton « Annotation ». */}
          <span
            aria-hidden
            className="absolute -bottom-1.5 size-3 rotate-45 border-r border-b border-line bg-surface"
            style={{ left: Math.min(22, left) - 6 }}
          />
        </Motion>
      )}
    </Presence>
  );
}
